(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-basvuru-formu"] && !Shopify.designMode) return;
  try {
    
  class B2bApplicationForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.alert = this.querySelector('.b2b-form__alert');
      this.done = this.querySelector('.b2b-form__done');
      this.button = this.form.querySelector('[type="submit"]');
      this.form.addEventListener('submit', (event) => this.submit(event));
    }

    clearErrors() {
      this.alert.hidden = true;
      this.alert.textContent = '';
      this.querySelectorAll('.b2b-form__field-error').forEach((node) => node.remove());
      this.querySelectorAll('[aria-invalid="true"]').forEach((node) => node.removeAttribute('aria-invalid'));
    }

    showFieldErrors(fields) {
      let first = null;
      Object.entries(fields || {}).forEach(([name, message]) => {
        const field = this.form.querySelector(`[name="${name}"]`);
        if (!field) return;
        field.setAttribute('aria-invalid', 'true');
        const note = document.createElement('p');
        note.className = 'b2b-form__field-error';
        note.textContent = message;
        (field.closest('.form-control') || field.parentElement).appendChild(note);
        if (!first) first = field;
      });
      if (first) first.focus({ preventScroll: false });
    }

    showAlert(message) {
      this.alert.textContent = message;
      this.alert.hidden = false;
    }

    async submit(event) {
      event.preventDefault();
      this.clearErrors();

      const endpoint = this.dataset.endpoint;
      if (!endpoint) {
        this.showAlert(this.form.dataset.errorConfig || 'Form yapılandırması eksik.');
        return;
      }

      const file = this.form.querySelector('[name="vergi_levhasi"]');
      const maxBytes = Number(this.dataset.maxMb || 10) * 1024 * 1024;
      if (file && file.files.length && file.files[0].size > maxBytes) {
        this.showFieldErrors({ vergi_levhasi: this.form.dataset.errorSize });
        return;
      }

      this.button.disabled = true;
      const original = this.button.textContent;
      this.button.textContent = this.form.dataset.sending || original;

      try {
        const response = await fetch(endpoint, { method: 'POST', body: new FormData(this.form) });
        const payload = await response.json().catch(() => ({}));

        if (!response.ok) {
          if (payload.alanlar) this.showFieldErrors(payload.alanlar);
          this.showAlert(payload.hata || this.form.dataset.errorGeneric);
          return;
        }

        this.form.hidden = true;
        this.done.hidden = false;
        this.done.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (error) {
        this.showAlert(this.form.dataset.errorNetwork);
      } finally {
        this.button.disabled = false;
        this.button.textContent = original;
      }
    }
  }

  customElements.define('b2b-application-form', B2bApplicationForm);

  } catch(e) { console.error(e); }
})();
})();
